(function() {
	'use strict';
	
	angular.module('app.core').filter('dateYearFirst', function() {
		return function(input) {
			var m = moment(input);
			return m.format('YYYY-MM-DD');
		};
	});
})();;